import api from '../../api'
import router from '../../router'
import stompSocket from '../../plugins/socketIO'
import store from '../index'

export default {
  state: () => ({
  }),
  getters: {
  },
  actions: {
    async signIn({ commit }, payload) {
      const { data } = await api.auth.signIn(payload)
      localStorage.setItem('token', data.token)
      localStorage.setItem('hideCampaignReminder', 'false')
      stompSocket.connect()
    },
    async signOut() {
      localStorage.removeItem('token')
      stompSocket.disconnect()
      store.clearGameState()
      await router.push('/')
    },
  },
  mutations: {
  },
}
